// 文档类型
enum documentType {
    Order = "订单",
    DespatchAdvice = "发货单",
    ReceiptAdvice = "收货单",
    StockInNotice = "入库通知单",
    ForecastDemand = "要货计划",
    ForecastPrediction = "预测计划",
    ReceiptAdviceRATC01 = "冲销入库单",
    ReceiptAdviceReturn = "退货通知单",
    Contract = "合同",
    Reconciliation = "对账单",
    ProductActivity = "商品变动单",
    Invoice = "发票",
}
// 美元USD 人民币CNY
enum currencyType {
    USD = "美元",
    CNY = "人民币",
}

// 角色
enum role {
    Buyer = "采购",
    Seller = "销售",
}
// 单据状态
enum status {
    DRAFT = "草稿",
    SENT = "已发送",
    RECEIVED = "已接收",
    ACCEPTED = "已接受",
    REJECTED = "已拒绝",
    CANCEL_REQUESTING = "申请作废",
    CANCEL_REJECTED = "拒绝作废",
    CANCELED = "已作废",
    ISSUED = "已开具"
}
// 支付方式
enum paymentMeans {
    PMZ01 = "现金转账",
    PMZ02 = "承兑汇票",
    PMZ03 = "支票",
    PMZ04 = "本票",
    PMZ05 = "L/C 信用证",
    PMZ06 = "T/T 电汇",
    PMZ07 = "D/A 承兑交单",
    PMZ08 = "D/P 付款交单",
}
// 单位
enum unitCode {
    TNE = "吨",
    KGM = "千克",
    MTR = "米",
    ST = "片",
    ZZ1 = "支",
    EA = "个",
    SET = "套",
    BX = "盒",
    ZZ0 = "台",
    CS = "箱",
    PK = "包",
    BO = "瓶",
    H87 = "件",
}
// 运输方式
enum TransportModeCode {
    TMC1 = "水运",
    TMC2 = "火车",
    TMC3 = "陆运",
    TMC4 = "空运",
}
export default { 
    documentType,
    currencyType,
    role,
    status,
    unitCode,
    paymentMeans,
    TransportModeCode,
 };


// WEBPACK FOOTER //
// ./src/display/platform/Document/ModelData.ts